import {DataObjectId, Hub} from 'yougile-model'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {getColumnsOptions} from './get-columns-options'

export const getInitColumns = (
  boardId: DataObjectId,
  editHub?: Hub
): OptionsItemCheckbox[] => {
  if (editHub) {
    if (editHub.data.movementTemplate.moveFromColumnsAllIn) {
      return getColumnsOptions(boardId, true)
    }

    const selectedIds = editHub.data.movementTemplate.moveFromColumns

    const options = getColumnsOptions(boardId, false)
    for (const option of options) {
      if (selectedIds.includes(option.id)) {
        option.selected = true
      }
    }

    return options
  }

  return getColumnsOptions(boardId, true)
}
